/* eslint-disable */
export default {
  name: 'search-form',

  ui: {
    input: '[js-search-form-input]',
  },

  events: [
    {
      on: 'submit',
      handle(e) {
        e.preventDefault()
        this.goToURL()
      },
    },
  ],

  componentDidMount() {
    this.el.classList.add('has-transition')
    this.ui.input.addEventListener('keydown', this.keyboardListener)
  },

  componentWillUnmount() {
    this.ui.input.removeEventListener('keydown', this.keyboardListener)
  },

  keyboardListener(e) {
    const key = e.which || e.keyCode
    // console.log(key)
    if (key === 13) {
      // 13 is enter
      this.goToURL()
    } else if (key === 27 || key === 'Escape') {
      // 27 is escape
    }
  },

  strip(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html')
    return doc.body.textContent || ''
  },

  goToURL() {
    const baseUrl = this.props.url.split('?')[0]
    
    if (this.ui.input.value !== '') {
      const query = this.strip(this.ui.input.value)
      const url = `${baseUrl}?query=${query}`
      window.location.href = url
    }
  },
}
/* eslint-enable */
